/**
 * Empty Indicator Mode.
 * @public
 */
enum TextEmptyIndicatorMode {
	/**
	 * Empty indicator is never rendered.
	 * @public
	 */
	Off = "Off",

	/**
	 * Empty indicator is rendered always when the component's content is empty.
	 * @public
	 */
	On = "On",
}

export default TextEmptyIndicatorMode;
